import React, { useEffect, useState } from "react";
import pay from "../Images/pay.png";
import {
  Table,
  Button,
  Pagination,
  Row,
  Col,
  Container,
  Form,
  Card,
} from "react-bootstrap";
import BgWomen from "../Images/LinkGuestImgs/employeeBg.png";
import Card1 from "../Images/gp1.png";
import Card2 from "../Images/gp2.png";
import Card3 from "../Images/gp3.png";
import Card4 from "../Images/gp4.png";
import { FaDollarSign } from "react-icons/fa";
import { CgLogIn } from "react-icons/cg";
import { FaGlobe, FaLanguage, FaRegClock } from "react-icons/fa";
import { FaStar } from "react-icons/fa";
import Nav from "./Navbar";
import Footer from "./Footer";
import Testimonials from "./Testonomial";
import LogoSlider from "./logopartner";
import { Helmet } from "react-helmet";
const BackLinkGuest = () => {
  const dummyData = [
    {
      website: "newssite.com",
      categories: ["General", "All Niches"],
      traffic: "29,043,069",
      ahrefs: 82,
      moz: 78,
      lang: "English",
      price: "$19.95",
    },
    {
      website: "venturespot.io",
      categories: ["General", "News and Media", "All Niches"],
      traffic: "48,882",
      ahrefs: 77,
      moz: 64,
      lang: "English",
      price: "$39.90",
    },
    {
      website: "timelynews.org",
      categories: ["General", "Marketing", "News and Media"],
      traffic: "42,652",
      ahrefs: 71,
      moz: 60,
      lang: "English",
      price: "$19.95",
    },
    {
      website: "bigbiz.com",
      categories: ["Business", "Lifestyle", "Sports"],
      traffic: "147,520",
      ahrefs: 77,
      moz: 66,
      lang: "English",
      price: "$19.95",
    },
    {
      website: "pathforward.net",
      categories: ["General", "All Niches"],
      traffic: "117,720,751",
      ahrefs: 93,
      moz: 91,
      lang: "English",
      price: "$19.95",
    },
    {
      website: "contentboost.co",
      categories: ["General", "SEO", "Marketing"],
      traffic: "31,500",
      ahrefs: 70,
      moz: 68,
      lang: "English",
      price: "$24.99",
    },
    {
      website: "contentboost.co",
      categories: ["General", "SEO", "Marketing"],
      traffic: "31,500",
      ahrefs: 70,
      moz: 68,
      lang: "English",
      price: "$24.99",
    },
    {
      website: "contentboost.co",
      categories: ["General", "SEO", "Marketing"],
      traffic: "31,500",
      ahrefs: 70,
      moz: 68,
      lang: "English",
      price: "$24.99",
    },
    {
      website: "contentboost.co",
      categories: ["General", "SEO", "Marketing"],
      traffic: "31,500",
      ahrefs: 70,
      moz: 68,
      lang: "English",
      price: "$24.99",
    },
  ];
  const PlatformData = [
    {
      id: 1,
      title: " Buyer Registration and Account Setup",
      description:
        "Buyer registration and account setup on SeoBix is quick, secure, and hassle-free. With just a few simple steps, you can create your profile, verify your email, and start exploring influencer campaigns. SeoBix ensures a smooth onboarding experience so you can focus on building your brand. Get started today and unlock access to top-tier content creators.",
    },
    {
      id: 2,
      title: "Publisher Search and Task Assignment",
      description:
        "Publisher Search and Task Assignment on SeoBix is designed for speed and precision. Easily find the right content publishers using smart filters based on niche, audience, and performance. Assign tasks directly from your dashboard and manage collaborations seamlessly. With SeoBix, connecting with the right talent is just a few clicks away.",
    },
    {
      id: 3,
      title: "Task Creation and Submission",
      description:
        "Task Creation and Submission on SeoBix is simple and streamlined. Create detailed campaign tasks with clear guidelines, deadlines, and deliverables all from your dashboard. Publishers can submit their work directly for your review, ensuring smooth collaboration. SeoBix makes managing content tasks efficient and hassle-free.",
    },
    {
      id: 4,
      title: "Task Progress Monitoring and Communication",
      description:
        "With SeoBix, Task Progress Monitoring and Communication are effortless and transparent. Track every stage of your campaign in real time and stay updated on publisher activity. Use the built-in chat feature for instant communication and quick clarifications. SeoBix keeps your workflow organized and your collaborations smooth.",
    },
  ];
  const WhyChooseData = [
    {
      id: "1",
      title: "Extensive Network Access",
      text: "SeoBix offers Extensive Network Access to a wide pool of verified influencers and content publishers across various niches and platforms. Easily find the perfect match for your campaign goals with powerful search and filter options. Whether local or global, SeoBix connects you to the right talent. Expand your reach and boost your brand visibility effortlessly.",
      image: Card1,
    },
    {
      id: "2",
      title: "Quality Assurance Standards",
      text: "SeoBix maintains strict Quality Assurance Standards to ensure every campaign meets professional benchmarks. All publishers are vetted, and content is reviewed for accuracy, relevance, and brand alignment. With built-in approval workflows, you stay in control of quality at every step. Trust SeoBix to deliver consistent, high-standard results.",
      image: Card2,
    },
    {
      id: "3",
      title: "Seamless Collaboration Tools",
      text: "SeoBix offers Seamless Collaboration Tools that make working with influencers and publishers smooth and efficient. From real-time chat to task updates and file sharing, everything happens in one place. These tools ensure clarity, faster feedback, and streamlined workflows. With SeoBix, collaboration feels effortless and productive.",
      image: Card3,
    },
    {
      id: "4",
      title: "Cost-Effective Solutions",
      text: "SeoBix provides Cost-Effective Solutions for brands looking to maximize their marketing impact without overspending. With flexible pricing, transparent transactions, and access to a wide range of publishers, you get great value for every campaign. SeoBix helps you achieve results while staying within budget. Smart marketing starts here.",
      image: Card4,
    },
  ];

  const [currentPage, setCurrentPage] = useState(1);
  const perPage = 6;

  const paginatedData = dummyData.slice(
    (currentPage - 1) * perPage,
    currentPage * perPage
  );

  const totalPages = Math.ceil(dummyData.length / perPage);
  const Counter = ({ end, duration = 2000 }) => {
    const [count, setCount] = useState(0);

    useEffect(() => {
      const start = 0;
      const increment = end / (duration / 16);
      let current = start;

      const timer = setInterval(() => {
        current += increment;
        if (current >= end) {
          setCount(end);
          clearInterval(timer);
        } else {
          setCount(Math.floor(current));
        }
      }, 16);

      return () => clearInterval(timer);
    }, [end, duration]);

    const formatted = count.toLocaleString();

    return <span>{formatted}+</span>;
  };
  const jsonLdData = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    name: "Guest Posting Site | Publish & Grow Your Online Reach",
    url: "https://seobix.com/guest-post",
    description:
      "Join our guest posting network. Share your articles, build high-quality backlinks, and enhance your online visibility with genuine content collaborations.",
    publisher: {
      "@type": "Organization",
      name: "Seobix",
      url: "https://seobix.com",
      logo: {
        "@type": "ImageObject",
        url: "https://seobix.com/Images/Backlinks.png",
      },
    },
    breadcrumb: {
      "@type": "BreadcrumbList",
      itemListElement: [
        {
          "@type": "ListItem",
          position: 1,
          name: "Guest Posting Tool",
          item: "https://seobix.com/guest-post",
        },
      ],
    },
    mainEntity: {
      "@type": "SoftwareApplication",
      name: "Guest Posting Tool",
      applicationCategory: "SEO Tool",
      operatingSystem: "Web",
      offers: {
        "@type": "Offer",
        price: "0",
        priceCurrency: "USD",
        category: "Free SEO Tool",
      },
    },
    inLanguage: "en",
    keywords: [
      "seo guest posting sites",
      "cheap guest posts",
      "websites that accept guest posts",
      "backlink guest post",
      "paid guest post sites",
      "guest posting fiverr",
      "best guest posting website",
      "business accepting guest posts",
      "get guest posts",
      "top guest post websites",
      "guest post exchange",
      "websites for guest posting",
      "guest post digital marketing",
      "guest post examples",
      "guest post links",
    ],
    mainEntityOfPage: [
      {
        "@type": "Question",
        name: "What is guest posting?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Guest posting is the practice of publishing articles on other websites to build backlinks, increase exposure, and grow online presence.",
        },
      },
      {
        "@type": "Question",
        name: "Why should I use Seobix for guest posting?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Seobix provides a trusted guest posting network that helps you share articles, build high-quality backlinks, and enhance your website's visibility.",
        },
      },
      {
        "@type": "Question",
        name: "Are guest posts effective for SEO?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Yes, guest posts can improve your SEO by generating quality backlinks, driving referral traffic, and increasing domain authority.",
        },
      },
    ],
  };

  return (
    <div style={{ overflow: "hidden" }}>
      <div>
        {/* <div
 className="d-flex justify-content-center"
 style={{ background: "#fdca40" }}
 >
 <p className="p-2 m-0 text-center">
 Start with free trial of <b>SeoBix!</b> - boost your SEO
 game&nbsp;&nbsp;
 <Button size="sm" variant="success">
 Know More
 </Button>
 </p>
 </div> */}
        <Helmet>
          <title>Guest Posting Site | Publish & Grow Your Online Reach</title>
          <meta
            name="description"
            content="Join our guest posting network. Share your articles, build high-quality backlinks, and enhance your online visibility with genuine content collaborations."
          />
          <meta
            name="keywords"
            content="seo guest posting sites, cheap guest posts, websites that accept guest posts, backlink guest post, paid guest post sites, guest posting fiverr, best guest posting website, business accepting guest posts, get guest posts, top guest post websites, guest post exchange, websites for guest posting, guest post digital marketing, guest post examples, guest post links"
          />
          <link rel="canonical" href="https://seobix.com/guest-post" />

          <meta
            property="og:title"
            content="Guest Posting Site | Publish & Grow Your Online Reach"
          />
          <meta
            property="og:description"
            content="Join our guest posting network. Share your articles, build high-quality backlinks, and enhance your online visibility with genuine content collaborations."
          />
          <meta property="og:url" content="https://seobix.com/guest-post" />
          <meta property="og:site_name" content="Seobix" />
          <meta property="og:type" content="website" />
          <meta
            property="og:image"
            content="https://seobix.com/Images/Backlinks.png"
          />
          <meta property="og:image:width" content="600" />
          <meta property="og:image:height" content="600" />
          <meta property="og:locale" content="en_US" />

          <meta name="twitter:card" content="summary_large_image" />
          <meta
            name="twitter:title"
            content="Guest Posting Site | Publish & Grow Your Online Reach"
          />
          <meta
            name="twitter:description"
            content="Join our guest posting network. Share your articles, build high-quality backlinks, and enhance your online visibility with genuine content collaborations."
          />
          <meta
            name="twitter:image"
            content="https://seobix.com/Images/Backlinks.png"
          />
          <meta name="twitter:site" content="@seobix" />
          <meta name="twitter:creator" content="@seobix" />

          <script type="application/ld+json">
            {JSON.stringify(jsonLdData)}
          </script>
        </Helmet>
        <Nav />
      </div>
      <div
        className="min-vh-100 d-flex align-items-center"
        style={{
          backgroundImage: `url(${BgWomen})`,
          backgroundSize: "cover",
          backgroundPosition: "center top",
          backgroundRepeat: "no-repeat",
          width: "100%",
          minHeight: "100vh",
          position: "relative",
        }}
      >
        <div
          className="w-100 h-100"
          style={{
            background:
              "linear-gradient(to right, rgba(175, 221, 255, 0.8), rgba(255, 255, 255, 0.8))",
            position: "absolute",
            top: 0,
            left: 0,
            zIndex: 1,
          }}
        ></div>
        <div className="container" style={{ position: "relative", zIndex: 2 }}>
          <div className="row justify-content-center align-items-center text-center">
            <div className="col-md-2"></div>
            <div className="col-12 col-md-8">
              <h1
                className="fw-bold  mb-3"
                style={{
                  fontSize: "3rem",
                  fontWeight: 700,
                  color: "#113F67",
                }}
              >
                Premium Guest Posting&nbsp;
                <span style={{ color: "#B12C00" }}>Services</span>
              </h1>
              <h3
                className="fw-bold  mb-2"
                style={{ fontSize: "1.5rem", color: "#113F67" }}
              >
                Get <span style={{ color: "#B12C00" }}>Backlinks</span> From
                High-Quality Websites
              </h3>
              <h4
                className=" mb-4"
                style={{
                  fontWeight: 400,
                  fontSize: "1.1rem",
                  color: "#113F67",
                }}
              >
                Only Pay If You Are Satisfied With The Results
              </h4>
              <div className="d-flex flex-column flex-md-row justify-content-center align-items-center gap-2 mb-2">
                <a
                  href="/register"
                  className="btn btn-light btn-lg fw-bold me-md-3 mb-2 mb-md-0"
                  style={{ minWidth: 180 }}
                >
                  <i className="fa fa-sign-in-alt me-2" /> <CgLogIn /> Sign Up
                  Now
                </a>
                <a
                  href="/pricing-plans"
                  className="btn btn-primary btn-lg fw-bold"
                  style={{ minWidth: 180 }}
                >
                  <FaDollarSign className="me-2" /> View Pricing
                </a>
              </div>
              <div
                className=" fw-bold mt-2"
                style={{ fontSize: "1rem", color: "#B12C00" }}
              >
                * Starting From $29.99
              </div>
            </div>
            <div className="col-md-2"></div>
          </div>
        </div>
      </div>

      <div className="row ">
        <div className="col-12 col-md-12 text-center">
          {/* Blue content */}
          <div
            className="row mb-4"
            style={{ backgroundColor: "#0c1d35", color: "white" }}
          >
            <div className="col-md-4 mb-3 mt-3">
              <h4 style={{ fontWeight: "bold" }}>
                <Counter end={60416} duration={2000} />
              </h4>
              <p className="mb-0">Registered Websites</p>
            </div>

            <div className="col-md-4 mb-3 mt-3">
              <h4 style={{ fontWeight: "bold" }}>
                <Counter end={34750} duration={2000} />
              </h4>
              <p className="mb-0">Publishers & Writers</p>
            </div>

            <div className="col-md-4 mb-3 mt-3">
              <h4 style={{ fontWeight: "bold" }}>
                <Counter end={365304} duration={2000} />
              </h4>
              <p className="mb-0">Tasks Completed</p>
            </div>
          </div>

          {/* Feature logos */}
        </div>
        <Row className="d-flex justify-content-center mt-md-5 mt-2 mb-md-5 mb-2  mx-1">
          <Col md={10}>
            <LogoSlider />
          </Col>
        </Row>
      </div>

      {/* increasing the visibility div */}
      <div className="row d-flex justify-content-center">
        <div className="col-10 my-5">
          {/* Header */}
          <div className="text-center mb-4">
            <h2 className="fw-bold">
              Increasing The Visibility Of Your Website
            </h2>
            <p className="text-muted">
              Accelerate Your Business Growth With Our Services
            </p>
          </div>

          {/* Table */}
          <div className="container my-5">
            <div
              className=" p-3 rounded "
              style={{
                background:
                  "linear-gradient(to right, rgba(175, 221, 255, 0.8), rgba(255, 255, 255, 0.8))",
              }}
            >
              <h6
                className="mb-3 fw-bold text-center"
                style={{ color: "#3c5a99" }}
              >
                600 Websites & Blogs That Accept Guest Posts
              </h6>
              <div className="table-responsive">
                <table className="table table-bordered align-middle text-center">
                  <thead className="table-light">
                    <tr>
                      <th>Website</th>
                      <th>Categories</th>
                      <th>Monthly Traffic</th>
                      <th>Ahrefs DR</th>
                      <th>Moz DA</th>
                      <th>Language</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {paginatedData.map((site, index) => (
                      <tr key={index}>
                        <td>
                          <FaGlobe className="me-1" />
                          <span className="fw-medium">{site.website}</span>
                          <br />
                          <small className="text-muted">
                            Max 03 DoFollow links
                            <br />
                            <FaRegClock className="me-1" />
                            Turnaround Time:
                            <span className="text-primary">1 day</span>
                          </small>
                        </td>
                        <td>
                          {site.categories.map((cat, i) => (
                            <span key={i} className="badge bg-secondary me-1">
                              {cat}
                            </span>
                          ))}
                        </td>
                        <td>
                          <span className="text-warning fw-semibold">
                            📈 {site.traffic}
                          </span>
                        </td>
                        <td>
                          <span className="badge bg-primary">
                            DR {site.ahrefs}
                          </span>
                        </td>
                        <td>
                          <span className="badge bg-info text-dark">
                            DA {site.moz}
                          </span>
                        </td>
                        <td>
                          <FaLanguage className="me-1" />
                          {site.lang}
                        </td>
                        <td>
                          <div className="action-buttons">
                            <div className="btn-combo">
                              <button
                                className="left-btn"
                                onClick={() =>
                                  (window.location.href =
                                    "https://dashboard.seobix.com/")
                                }
                              >
                                Buy Post
                              </button>
                              <button
                                className="right-btn"
                                onClick={() =>
                                  (window.location.href =
                                    "https://dashboard.seobix.com/")
                                }
                              >
                                {site.price}
                              </button>
                            </div>
                            <button
                              className="btn btn-view w-100"
                              onClick={() =>
                                (window.location.href =
                                  "https://dashboard.seobix.com/")
                              }
                            >
                              View Details
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              {/* Pagination - Hidden if only 1 page */}
              {totalPages > 1 && (
                <nav className="d-flex justify-content-end mt-3">
                  <ul className="pagination pagination-sm mb-0">
                    {Array.from({ length: totalPages }, (_, i) => (
                      <li
                        key={i}
                        className={`page-item ${
                          currentPage === i + 1 ? "active" : ""
                        }`}
                      >
                        <button
                          className="page-link"
                          onClick={() => setCurrentPage(i + 1)}
                        >
                          {i + 1}
                        </button>
                      </li>
                    ))}
                  </ul>
                </nav>
              )}
            </div>

            {/* Custom styles */}
            <style jsx>{`
              .table tbody tr:hover {
                background-color: #f3f6fa;
              }

              /* Make category column narrower */
              .table td:nth-child(2) {
                width: 160px;
              }

              .action-buttons {
                display: flex;
                flex-direction: column;
                gap: 4px;
                align-items: center;
              }

              .btn-combo {
                display: flex;
                flex-direction: row;
                width: 100%;
                height: 36px;
                border-radius: 5px;
                overflow: hidden;
                box-shadow: 0 0 0 1px #ccc;
              }

              .left-btn,
              .right-btn {
                flex: 1;
                border: none;
                font-size: 14px;
                padding: 6px 10px;
                cursor: pointer;
                transition: all 0.3s ease;
                height: 100%;
              }

              .left-btn {
                background-color: #f8f9fa;
                color: #000;
              }

              .left-btn:hover {
                background-color: #e2e6ea;
              }

              .right-btn {
                background-color: #2c7be5;
                color: #fff;
              }

              .right-btn:hover {
                background-color: #2566c8;
              }

              .btn-view {
                margin-top: 6px;
                font-size: 14px;
                color: #dc3545;
                border: 1px solid #dc3545;
              }

              .btn-view:hover {
                background-color: #dc3545;
                color: #fff;
              }

              @media (max-width: 576px) {
                .btn-combo {
                  flex-direction: column;
                  height: auto;
                }

                .left-btn,
                .right-btn {
                  width: 100%;
                  height: 36px;
                }
              }
              .btn-view {
                margin-top: 6px;
                font-size: 14px;
                color: #dc3545;
                border: 1px solid #dc3545;
              }

              .btn-view:hover {
                background-color: #dc3545;
                color: #fff;
              }
            `}</style>
          </div>
          <Plancard />
          <Testimonials />
          <div className="">
            <h2
              className="text-center fw-bold mb-5"
              style={{ color: "#3c5a99" }}
            >
              How Our Platform Works
            </h2>
            <div className="row g-4">
              {PlatformData.map((item) => (
                <div className="col-12 col-sm-6 col-lg-3" key={item.id}>
                  <div className="card h-100 border border-primary rounded-3 shadow-sm">
                    <div className="card-body">
                      <div className="d-flex align-items-start">
                        <div
                          className="rounded-circle d-flex align-items-center justify-content-center me-2 shadow-sm"
                          style={{
                            width: "32px",
                            height: "32px",
                            borderRadius: "50%",
                            backgroundColor: "#3c5a99",
                            color: "#fff",
                            fontWeight: "bold",
                          }}
                        >
                          {item.id}
                        </div>
                        <h6
                          className="card-title mb-2"
                          style={{ color: "#3c5a99", fontWeight: "bold" }}
                        >
                          {item.title}
                        </h6>
                      </div>
                      <p className="card-text mt-2">{item.description}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
            <style jsx>
              {`
                .card-title {
                  font-size: 1rem;
                }

                .card-text {
                  font-size: 0.95rem;
                  line-height: 1.5;
                }

                .shadow-sm {
                  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.08) !important;
                }
              `}
            </style>
          </div>
          <div className="">
            <h2
              className="text-center fw-bold m-5"
              style={{ color: "#3c5a99" }}
            >
              Why Choose Us
            </h2>
            <div className="row justify-content-center">
              {WhyChooseData.map((item) => (
                <div
                  className="col-12 col-sm-6 col-md-6 col-lg-3 p-1"
                  key={item.id}
                >
                  <div className="card border h-100 border-primary overflow-hidden">
                    <img
                      src={item.image}
                      alt={item.title}
                      className="card-img-top"
                      style={{
                        width: "100%",
                        margin: 0,
                        padding: 0,
                        borderBottom: "1px solid #dee2e6",
                      }}
                    />
                    <div className="card-body">
                      <div className="card-title text-facebook font-weight-bold align-items-center d-flex">
                        <span
                          style={{ color: "#3c5a99", fontWeight: "bold" }}
                          className="flex-1"
                        >
                          {item.title}
                        </span>
                      </div>
                      <p className="card-text">{item.text}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      <Plancard />
      <div
        className="m-0 p-0"
        style={{
          overflow: "hidden",
          background:
            "linear-gradient(to right, rgb(175, 221, 255), rgb(255, 255, 255))",

          borderTopRightRadius: "2rem",
          borderTopLeftRadius: "2rem",
        }}
      >
        <Footer />
      </div>
    </div>
  );
};
const Plancard = () => {
  const [isYearly, setIsYearly] = useState(false);
  const plans = [
    {
      title: "Free",
      monthly: "$0",
      yearly: "$0",
      Free: "3 Month Free Trial",
      features: ["Limited Access"],
      buttonText: "Buy Plan",
      color: "#e0f2fe",
      border: "#38bdf8",
      image: pay,
    },
    {
      title: "Basic",
      monthly: "$150/mo",
      features: ["5 Projects", "Standard Reports", "Email Support"],
      buttonText: "Buy Plan",
      color: "#e7f5ff",
      border: "#339af0",
      image: pay,
    },
    {
      title: "Standard",
      monthly: "$350/mo",
      features: ["10 Projects", "Advanced Reports", "Priority Support"],
      buttonText: "Buy Plan",
      color: "#e6fcf5",
      border: "#20c997",
      image: pay,
    },
    {
      title: "Premium",
      monthly: "$750/mo",
      features: ["Unlimited Projects", "All Features", "24/7 Support"],
      buttonText: "Buy Plan",
      color: "#fff3bf",
      border: "#fcc419",
      image: pay,
    },
  ];

  return (
    <Container className="my-5">
      <div className="text-center mb-4">
        <h2 style={{ fontWeight: "700", fontSize: "2rem" }}>
          Boost Your SEO With Our Amazing Plans
        </h2>
        <h4 className="font-weight-bold mb-4" style={{ color: "#441752" }}>
          🚀 Improve Your Rankings —{" "}
          <span style={{ color: "#FC4100" }}>
            Try Our Service Free for 3 Months!
          </span>
        </h4>
        <p style={{ color: "#6b7280" }}>
          Flexible pricing plans designed for every stage of your journey
        </p>
        <div className="d-flex justify-content-center mt-4">
          <div className="d-flex align-items-center gap-2">
            <span style={{ fontWeight: "500" }}>Monthly</span>

            <div
              className="m-2"
              style={{ transform: "scale(1.5)", transformOrigin: "center" }}
            >
              <Form.Check
                type="switch"
                id="custom-switch"
                checked={isYearly}
                onChange={() => setIsYearly(!isYearly)}
              />
            </div>

            <div className="d-flex align-items-center gap-2">
              <span style={{ fontWeight: "500" }}>Yearly</span>

              <div
                className="start-now-btn mx-3"
                style={{
                  backgroundColor: "#e6f4ea",
                  color: "#2f855a",
                  padding: "6px 12px",
                  borderRadius: "8px solid",
                  fontWeight: "600",
                  fontSize: "0.9rem",
                  border: "1px solid #20c997",
                }}
              >
                🎉{" "}
                <span style={{ color: "#0B1D51" }}>
                  Get{" "}
                  <span style={{ color: "#0B1D51" }}>
                    <b>30% OFF</b>
                  </span>{" "}
                  on Yearly Plans
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Row className="g-4 justify-content-center">
        {plans.map((plan, idx) => (
          <Col md={6} lg={3} key={idx}>
            <div style={{ position: "relative" }}>
              {plan.title === "Free" && (
                <div
                  style={{
                    position: "absolute",
                    top: "-12px",
                    left: 0,
                    right: 0,
                    height: "32px",
                    backgroundColor: "#38bdf8",
                    color: "white",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontWeight: "700",
                    fontSize: "1rem",
                    borderTopLeftRadius: "16px",
                    borderTopRightRadius: "16px",
                    zIndex: 2,
                  }}
                >
                  {plan.Free}
                </div>
              )}

              <Card
                className="p-2"
                style={{
                  backgroundColor: plan.color,
                  border: `2px solid ${plan.border}`,
                  borderRadius: "16px",
                  textAlign: "center",
                  height: "100%",
                  boxShadow:
                    plan.title === "Free"
                      ? "0 12px 28px rgba(56, 189, 248, 0.5)"
                      : "0 4px 12px rgba(0,0,0,0.05)",
                  marginTop: plan.title === "Free" ? "16px" : "0",
                }}
              >
                <Card.Body>
                  <Card.Title style={{ fontSize: "1.5rem", fontWeight: "700" }}>
                    {plan.title}
                  </Card.Title>
                  <h3 style={{ fontWeight: "bold", margin: "1rem 0" }}>
                    {isYearly
                      ? plan.title === "Free"
                        ? plan.yearly
                        : (() => {
                            const monthlyPrice = parseFloat(
                              plan.monthly.replace(/[^0-9.]/g, "")
                            );
                            const yearlyRaw = monthlyPrice * 12;
                            const discounted = yearlyRaw * 0.7;
                            return `$${Math.round(discounted)}/yr`;
                          })()
                      : plan.monthly}
                  </h3>
                  <a
                    href="/register"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      display: "inline-block",
                      backgroundColor: plan.border,
                      color: "white",
                      textDecoration: "none",
                      borderRadius: "999px",
                      padding: "8px 20px",
                      fontWeight: "600",
                      marginTop: "1rem",
                    }}
                  >
                    {plan.buttonText}
                  </a>

                  <div className="mt-3">
                    <img
                      src={plan.image}
                      alt={plan.title}
                      style={{
                        // width: "15vw",
                        objectFit: "contain",
                        marginBottom: "1rem",
                      }}
                    />
                  </div>
                </Card.Body>
              </Card>
            </div>
          </Col>
        ))}
      </Row>
    </Container>
  );
};
export default BackLinkGuest;
